export default {
    changeSideMenuState(context, payload) {
        context.commit("setSideMenuState", payload);
    }
}